import { Component, computed, effect, inject, signal, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DxDataGridComponent } from 'devextreme-angular';
import { DataService } from 'src/app/services/data.service';
import { IKostengruppe } from 'src/app/types/IKostengruppe';
import { DialogTeilleistungenData } from 'src/app/types/infrastructure/interfaces/IDialogTeileistungenData';
import { ITeilleistung } from 'src/app/types/ITeilleistung';
import { Kostengruppe } from 'src/app/types/Kostengruppe';

@Component({
  selector: 'app-budget-teilleistungen',
  // standalone: true,
  // imports: [],
  templateUrl: './budget-teilleistungen.component.html',
  styleUrl: './budget-teilleistungen.component.css'
})
export class BudgetTeilleistungenComponent {

  static readonly KOSTENGRUPPE: string = "Kostengruppe";

  @ViewChild("gridTeilleistungen", { static: false })
  public grid!: DxDataGridComponent;

  private readonly dialogRef = inject(MatDialogRef<BudgetTeilleistungenComponent>);
  private readonly dataService = inject(DataService);
  private readonly data = inject<DialogTeilleistungenData>(MAT_DIALOG_DATA);

  public allowEdit = signal<boolean>(this.data.allowEdit ?? false);
  public dataTeilleistungen = computed<ITeilleistung[] | null>(() => this.dataService.budgetantragKostenherleitung().teilleistungen);
  public dataKostengruppen = computed<IKostengruppe[] | null>(() => this.dataService.budgetantragKostenherleitung().kostengruppen);
  public dataTeilleistungenFilterd = signal<ITeilleistung[] | null>(this.dataTeilleistungen());
  public dataSelectionByKostengruppe = signal<Record<number, number[]>>({1: [], 2: [], 4: []});
  public dataSelections = () => this.dataSelectionByKostengruppe()[1].concat(this.dataSelectionByKostengruppe()[2], this.dataSelectionByKostengruppe()[4]);
  public gridDataCountText = computed(() => this.dataTeilleistungen()!.filter((teilleistung: ITeilleistung) => !this.data.idsExisting?.includes(teilleistung.teilleistungID))?.length + ' Datensätze');
  public gridInfoText = signal('0 Datensätze ausgewählt');

  public teilleistungenForm = new FormGroup({[BudgetTeilleistungenComponent.KOSTENGRUPPE]: new FormControl<IKostengruppe>(new Kostengruppe())});
  public readonly ctlKostengruppe = this.teilleistungenForm.get(BudgetTeilleistungenComponent.KOSTENGRUPPE)!;
  
  public constructor() {

    effect(() => {
      var kostengruppe = this.dataKostengruppen()?.find((x) => x.kostengruppeID == 1);
      this.teilleistungenForm.patchValue({[BudgetTeilleistungenComponent.KOSTENGRUPPE]: kostengruppe});
    });
  }

  ngOnInit() {

    // Teilleistung Gruppierung ergänzen um die Gruppierungsbezeichnungen
    this.dataTeilleistungen()!.forEach((teilleistung: ITeilleistung) => {
       teilleistung.bezeichnungGrouping01 = teilleistung.grouping01 + " " + this.dataTeilleistungen()!.filter((x) => x.nummer.toString() === teilleistung.grouping01)[0]?.bezeichnung;
       teilleistung.bezeichnungGrouping02 = teilleistung.grouping02 + " " + this.dataTeilleistungen()!.filter((x) => x.nummer.toString() === teilleistung.grouping02)[0]?.bezeichnung;
       });
    
    
    this.ctlKostengruppe.valueChanges.subscribe((value: ITeilleistung) => {
      this.dataTeilleistungenFilterd.set(
        //teilleistung.grouping01 != teilleistung.nummer.toString() && teilleistung.grouping02 != teilleistung.nummer.toString() &&
		this.dataTeilleistungen()!.filter((teilleistung: ITeilleistung) => {
          return  teilleistung.kostengruppeID === value.kostengruppeID && 
                 !this.data.idsExisting?.includes(teilleistung.teilleistungID);
        })
      );
      this.grid?.instance.refresh();
      // restore selection for current kostengruppe
      this.grid?.instance.selectRows(this.dataSelectionByKostengruppe()[value.kostengruppeID], false);
    });
  }

  onSelectionChanged(e: any): void {
    // sync current selection
    this.dataSelectionByKostengruppe()[this.ctlKostengruppe.value.kostengruppeID] = this.grid?.instance.getSelectedRowKeys() as number[];
    this.gridInfoText.set(this.dataSelections().length + ' Datensätze ausgewählt');
  }

  onCloseClick(): void {
    this.dialogRef.close();
  }

  isFormEditStateValid(): boolean {
    return this.allowEdit() && this.dataSelections().length > 0;
  }
  
  onFormSubmit() {
    this.data.kostengruppenId = this.ctlKostengruppe.value.kostengruppeID as number;
    this.data.idsSelected = this.dataSelections() as number[];
    this.dialogRef.close(this.data);
  }
}

